import { Component, OnInit, ViewEncapsulation, Inject, OnDestroy } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormGroup, FormBuilder, FormArray } from "@angular/forms";
import { PlayList } from '../shared/interface/playlist';
import { Dashboard } from '../shared/interface/dashboard';
import { PlaylistService } from '../shared/services/playlist/playlist.service';
import { DashboardService } from '../shared/services/dashboard/dashboard.service';
import { GroupService } from '../shared/services/group/group.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-play-list',
  templateUrl: './play-list.component.html',
  styleUrls: ['./play-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PlayListComponent implements OnInit, OnDestroy {
  dataSource: PlayList[];
  private _unsubscribeAll  : Subject<any> = new Subject<any>();
  constructor(
    public dialog: MatDialog,
    private playlistService: PlaylistService,
    public router: Router
  ) {

  }

  ngOnInit() {
    this.setList();
    this.playlistService.getAction().pipe(takeUntil(this._unsubscribeAll)).subscribe(data => {
      if ((["createPlaylist", "udpatePlaylist"]).includes(data.action)) {
        this.setList();
      }
    })
  }

  ngOnDestroy(){
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
  
  setList() {
    this.playlistService.list().pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      this.dataSource = res;
    }, (err) => { })
  }

  delete(_id) {
    if (
      confirm(
        "Are you sure you want to remove this playlist?"
      ) == false
    ) {
      return false;
    }

    let temp = this.dataSource;
    this.dataSource = this.dataSource.filter(item => item["_id"] !== _id);

    this.playlistService.delete(_id).pipe(takeUntil(this._unsubscribeAll)).subscribe(res => { }, (err) => {
      this.dataSource = temp;
    })
  }

  openPlayListDialog = (data = {}) => {
    this.dialog.open(PlayListDialog, {
      data: data,
      height: 'auto',
      width: '800px',
      panelClass: 'full-modal'
    });
  }

  playTheList(playList) {
    // console.log(playList);
    let url = 'private-dashboard/' + playList.mapped[0].dashboardName;
    url += '/' + playList.mapped[0].dashboardId;
    let qParams = {
      playlist: playList._id,
      play: '1',
      playIndex: '0-0'
    };
    this.router.navigate([url], { queryParams: qParams });
  }
}



@Component({
  selector: 'play-list-dialog',
  templateUrl: 'play-list.dialog.html'
})
export class PlayListDialog implements OnDestroy {
  playlistForm: FormGroup;
  dashboardList: Dashboard[];
  groupList = [];
  selectedGroups = {}
  isSubmitted: number = 0;
  private _unsubscribeAll  : Subject<any> = new Subject<any>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private playlistService: PlaylistService,
    private fb: FormBuilder,
    private dashboardService: DashboardService,
    private groupService: GroupService,
    public dialogRef: MatDialogRef<PlayListDialog>
  ) {
    data = Object.assign({}, data);
    data = this.parseForm(data);
    this.createForm(data);

    //fetch all dashboard
    this.dashboardService.list().pipe(takeUntil(this._unsubscribeAll)).subscribe(r => {
      this.dashboardList = r;

      //get all groups of respective dashboard
      let dl = data.mapped.length;
      if (dl > 0) {

        data.mapped.forEach((m, i) => {
          if (this.groupList[m.dashboardId]) {
            return;
          }

          this.groupList[m.dashboardId] = [];
          this.groupService.list(m.dashboardId, "fields=groupName").pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
            this.groupList[m.dashboardId] = res;

            if (i == (dl - 1)) {
              this.setDashboardAndGroup(data);
            }
          });
        })
      } else {
        this.setDashboardAndGroup(data);
      }
    });
  }

  ngOnDestroy(){
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  public parseForm(data: any) {
    if (data && data._id) {
      data.interval = data.interval / (60 * 1000);
      return data;
    }
    return {
      _id: "",
      playlistName: "",
      interval: "",
      mapped: []
    }
  }

  public createForm = (data: PlayList) => {
    this.playlistForm = this.fb.group({
      _id: data._id,
      playlistName: data.playlistName,
      interval: data.interval,
      mapped: this.fb.array([])
    })
  }


  setDashboardAndGroup(data: any) {
    let mg: any = this.dashboardList.map(m => {
      let tempM: any = m;
      tempM.dashboardId = tempM._id;
      tempM.dashboardSelected = false;
      tempM.groups = this.fb.array([]);
      data.mapped.forEach(v => {
        if (v.dashboardId == tempM.dashboardId) {
          tempM.dashboardSelected = true;
          this.groupList[tempM.dashboardId].forEach((gl, i) => {
            gl.groupSelected = false;
            v.groups.forEach(g => {
              if (g.groupId == gl._id) {
                gl.groupSelected = true;
              }
            });
            this.groupList[tempM.dashboardId][i] = gl;
          });
          tempM.groups = this.fb.array(this.groupList[tempM.dashboardId].map(g => {
            return this.fb.group(g)
          }));
        }
      });
      return this.fb.group(tempM);
    });
    let mA = this.fb.array(mg);
    this.playlistForm.setControl('mapped', mA);
  }

  getDashboard() {
    return <FormArray>this.playlistForm.get('mapped');
  }

  getDashboardGroups(i) {
    return <FormArray>this.playlistForm.get('mapped.' + i + '.groups');
  }

  getGroupList(i, dashboard) {
    let doBlank = 0;
    let dashboardId = dashboard._id;
    if (dashboard.dashboardSelected == false) {
      doBlank = 1;
    }
    if (!this.groupList[dashboardId]) {
      this.groupService.list(dashboardId, "fields=groupName").pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
        this.groupList[dashboardId] = res;
        this.setGroupList(i, dashboardId, doBlank);
      });
    } else {
      this.setGroupList(i, dashboardId, doBlank);
    }
  }

  setGroupList(i, dashboardId, doBlank = 0) {
    let dg = <FormGroup>this.playlistForm.get('mapped.' + i);
    if (doBlank == 1) {
      dg.setControl('groups', this.fb.array([]));
      return;
    }

    let tempG = this.groupList[dashboardId];

    tempG.forEach((gl, i) => {
      gl.groupSelected = false;
      tempG[i] = gl;
    });


    tempG = tempG.map(g => {
      return this.fb.group(g)
    });

    let gA = this.fb.array(tempG);
    dg.setControl('groups', gA);
  }

  public onSubmit(formValue) {
    this.isSubmitted = 1;
    let form = Object.assign({}, formValue);
    //create mapped array
    let tempMapper = [];
    form.mapped.forEach(m => {
      if (m.dashboardSelected == true) {
        let tm = {
          dashboardId: m._id,
          groups: []
        }
        m.groups.forEach(g => {
          if (g.groupSelected == true) {
            tm.groups.push(g._id);
          }
        });
        if (tm.groups.length > 0) {
          tempMapper.push(tm);
        }
      }
    });

    // console.log(arr);
    form.mapped = tempMapper;

    //convert time to miliseconds
    form.interval = form.interval * 60 * 1000;

    // console.log(form);
    if (form._id == "") {
      this.playlistService.create(form).pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
        this.dialogRef.close();
        this.playlistService.sendAction("createPlaylist", "");
        this.isSubmitted = 0;
      }, (err) => {
        this.isSubmitted = 0;
      })
    } else {
      form.playlistId = form._id;
      this.playlistService.update(form).pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
        this.dialogRef.close();
        this.playlistService.sendAction("createPlaylist", "");
        this.isSubmitted = 0;
      }, (err) => {
        this.isSubmitted = 0;
      })
    }
  }
}


// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/play-list/play-list.component.ts